<template>
    <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
            <!--begin::Title-->
            <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t(title) }}</h1>
            <!--end::Title-->
            <!--begin::Separator-->
            <span class="h-20px border-gray-300 border-start mx-4"></span>
            <!--end::Separator-->
            <!--begin::Breadcrumb-->

            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1 "  v-for="(bread,key) in breadcrumbs" :key="key">

                <li v-if="key+1 !== breadcrumbs.length" class="breadcrumb-item text-muted">
                    <router-link  :to="bread.path" class="text-muted text-hover-primary">{{  $t(bread.name) }}</router-link>
                    <span class="bullet bg-gray-200 w-5px h-2px m-2"></span>
                </li>


                <!--end::Item-->
                <!--begin::Item-->
                <li v-else class="breadcrumb-item text-dark">{{ $t(bread.name) }}</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <div class="m-0">
            <div class="input-group input-group-solid flex-nowrap">
            <span  class="input-group-text h-35px">  <i class="fs-3 fas fa-users" ></i></span>
              <div class="overflow-hidden ">

                <select  name="contact"  v-model="$route.params.id" data-control="select2" data-search="true" data-placeholder="Filter" class="form-select form-select-solid kt_select2 w-150px w-sm-250px h-35px" style="height: 34px;">
                  <option  v-for="contact in getContacts" :value="contact.id" :key="contact.id" >{{ contact.lastname}} {{ contact.firstname}}</option>
                </select>
              </div>
            </div>
          </div>

            <!--begin::Filter menu-->


            <div class="m-0">
                <!--              <a href="" class="btn btn-sm btn-primary m-2"  @click.prevent="openCreateModal">{{ $t('button.add') }}</a>-->

                <button v-if="back" @click="$goTo('/admin/contacts')" class="btn btn-sm btn-flex btn-light btn-active-primary fw-bolder">
                    <span class="svg-icon svg-icon-md">
                        <i class="fas fa-backspace"></i>
                    </span>{{$t("back")}}
                </button>

            </div>
            <!--end::Filter menu-->

        </div>
        <!--end::Actions-->
    </div>
</template>

<script>
import {Settings} from "luxon";

export default {
    props: {
        title: { required : true , type: String, default: 'Titre' },
        breadcrumbs: { required : false , type: Array, default: [] },
        back: { required : false , type: Boolean, default: false },
        getContacts: {type: Array, required: false ,default: [] },
    },
    data(){
        return {

        }
    },
    async mounted(){
        this.$parent.initSelect2()
    },

}
</script>
